import { useCallback, useState } from 'react'

const useModal = (): [boolean, () => void, () => void] => {
  const [open, setOpen] = useState<boolean>(false)
  const closeModal = useCallback(() => setOpen(false), [setOpen])
  const openModal = useCallback(() => setOpen(true), [setOpen])
  return [open, closeModal, openModal]
}

export default useModal
